import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import StarField from '../StarField';
import './index.scss';

const Layout = () => {
    const location = useLocation()
    const isProjectPage = location.pathname === '/project'
    const isAboutPage = location.pathname === '/about'
    const [navOpen, setNavOpen] = useState(false)

    // Add/remove a class on .App so Project's SCSS can override
    // .page and .container positioning without affecting other pages
    useEffect(() => {
        const appEl = document.querySelector('.App')
        if (!appEl) return
        if (isProjectPage) {
            appEl.classList.add('project-route-active')
        } else {
            appEl.classList.remove('project-route-active')
        }
        return () => appEl.classList.remove('project-route-active')
    }, [isProjectPage])

    useEffect(() => {
        const appEl = document.querySelector('.App')
        if (!appEl) return
        if (isAboutPage) {
            appEl.classList.add('about-route-active')
        } else {
            appEl.classList.remove('about-route-active')
        }
        return () => appEl.classList.remove('about-route-active')
    }, [isAboutPage])

    // Reset scroll on route change — .page is a persistent scroll container,
    // so scrollTop bleeds between About and Project otherwise.
    useEffect(() => {
        const pageEl = document.querySelector('.page')
        if (pageEl) pageEl.scrollTop = 0
        window.scrollTo(0, 0)
    }, [location.pathname])

    return (
        <div className="App">
            <StarField />
            <Sidebar navOpen={navOpen} setNavOpen={setNavOpen} />
            <div className={`page${navOpen ? ' nav-open' : ''}`}>
                <span className='tags top-tags'>
                    <span className='top-tag-html'>&lt;html&gt;</span>
                    <br />
                    &lt;body&gt;
                </span>

                <Outlet />

                <span className='tags bottom-tags'>&lt;/body&gt;
                <br />
                <span className='bottom-tag-html'>&lt;/html&gt;</span>
                </span>
            </div>
        </div>
    )
}

export default Layout